module.exports = __webpack_public_path__ + "img/hr-red-desert-bush-02.f20196a0.png";